//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import _ from 'lodash';
import INPUT from '../input.vue';
import CheckboxOption from '@/components/checkboxOption';
import { USER_PROPERTITY } from '@/utils/constant.js';
import { defaultFindStrategy, attributesApprovalTypes, resubmitPolicy } from '../../common';
import { mapGetters } from 'vuex';
import startNode from './startNode.vue';
import delaySettingNode from './delaySettingNode.vue';
import officalAcountNode from './officalAcountNode.vue';
import { defaultUserNodeFormValue } from '../../config';
import conditionalSelectionTreeVue from '../../components/conditionalSelectionTree.vue';
import inmailNode from './inmailNode.vue';
import gatewayNode from './gatewayNode.vue';
import inclusiveGatewayNode from './inclusvieGatewayNode.vue';
import functionWaitNode from './functionWaitNode.vue';
import doaApprovalNode from './doaApprovalNode.vue';
export default {
  name: 'WorkflowDetailConfigNode',
  components: {
    INPUT,
    CheckboxOption,
    delaySettingNode,
    startNode,
    officalAcountNode,
    inmailNode,
    gatewayNode,
    conditionalSelectionTreeVue,
    inclusiveGatewayNode,
    functionWaitNode,
    doaApprovalNode,
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    info: {
      type: Object,
      default: () => ({}),
    },
    graph: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      USER_PROPERTITY,
      attributesApprovalTypes,
      resubmitPolicy,
      // 输入输出变量弹框
      variableVisible: false,
      // 变量类型
      variableType: '',
      // 当前变量列表
      variableList: [],
      // 元数据弹框
      metadataVisible: false,
      // 审批人当前选项
      approvalSelect: 'start',
      // 选择指定审批人时搜索关键字获取的可选的用户列表
      candidateUserList: [],
      // 没有搜索关键字时按当前数据获取的已选择的用户列表
      selectedUserList: [],
      // 选择按属性匹配审批人时 可选的属性列表 包括角色列表 部门列表 地区列表
      userAttributeSelectInfo: {
        role: [],
        department: [],
        region: [],
      },
      // 选择属性标签后的审批人列表
      userListByTag: [],
      // 属性标签加载中
      attributesLoading: false,
      // 所有的云函数列表
      cloudFunctionList: [],
      // 已经选择的云函数列表
      selectedFunctionList: [],
      // 标签列表
      coustomConditionTags: [],
      // 对象字段列表
      objectFiledsList: [],
      loaded: false,
    };
  },
  computed: {
    ...mapGetters({
      businessEntityList: 'notice/getObjectList',
      startNodeObject: 'workflow/getStartNodeObject',
      getGatewayInclusiveState: 'workflow/getGatewayInclusiveState',
    }),
    computedFindStrategyOptions() {
      if (this.value.subref === 'prompt')
        return defaultFindStrategy.filter((item) => item.label !== '上级审批');
      switch (this.value.metadata.operator_type) {
        case 'custom_condition':
          return defaultFindStrategy.filter((item) => item.label !== '上级审批');
        default:
          return defaultFindStrategy;
      }
    },
    computedPreLeaderType() {
      if (this.approvalSelect !== 'pre') {
        return '';
      }
      return this.value.metadata.operator_value.leader_type;
    },
    computedCurrentLeaderType() {
      if (this.approvalSelect !== 'current') {
        return '';
      }
      return this.value.metadata.operator_value.leader_type;
    },
    multipleApprovalUser() {
      if (this.value.subref === 'prompt') return false;
      switch (this.value.metadata.operator_type) {
        case 'attribute':
          return this.value.metadata.operator_value.attribute_checked_user.length > 1;
        case 'candidate':
          return this.value.metadata.operator_value.candidate_user.length > 1;
        case 'custom_condition':
          return true;
        default:
          return false;
      }
    },
    computedFindStrategy() {
      switch (this.value.metadata.operator_type) {
        case 'leader':
          return this.value.metadata.operator_value.leader_find_strategy;
        case 'custom_condition':
          return this.value.metadata.operator_value.custom_condition_find_strategy;
        default:
          return '';
      }
    },
    findSignType() {
      switch (this.value.metadata.operator_type) {
        case 'leader':
          return '';
        case 'attribute':
          return this.value.metadata.operator_value.attribute_sign_type;
        case 'candidate':
          return this.value.metadata.operator_value.candidate_sign_type;
        case 'custom_condition':
          return this.value.metadata.operator_value.custom_condition_sign_type;
        default:
          throw new Error();
      }
    },
    // 列表排列顺序为：已选数据-搜索中数据
    nowUserList() {
      const notSelectedUser = this.candidateUserList.filter(({ account }) => {
        return !this.value.metadata.operator_value.candidate_user.includes(`(${account})`);
      });
      return this.selectedUserList.concat(notSelectedUser).map(this.showUserList);
    },
    nowFunctionList() {
      const notSelectedFunction = this.candidateUserList.filter(({ func_name }) => {
        return this.value.metadata.name !== func_name;
      });
      return this.cloudFunctionList.concat(notSelectedFunction);
    },
  },
  async created() {
    if (this.value.type === 'user') {
      this.userInit();
    } else if (this.value.type === 'start_node') {
      this.startNodeInit();
    } else if (['function', 'time_boundary_event', 'wait', 'doa'].includes(this.value.type)) {
      this.cloudFunctionInit();
    }

    if (this.startNodeObject) {
      const objId = this.businessEntityList.find(
        (object) => object.name === this.startNodeObject,
      )?.id;
      const { fields } = await this.$request({
        url: this.$api.metaGetObjectFields,
        data: {
          object_id: objId,
        },
      });
      this.objectFiledsList = fields;
    }
    this.loaded = true;
  },
  mounted() {},
  methods: {
    // 审批节点初始化
    userInit() {
      // 初始化标签列表
      this.getCoustomConditionTags();
      ['role', 'region', 'department'].forEach((tag) => this.getRoleSelectedList(tag));
      // 初始化当前选择的类型
      if (this.value.metadata.operator_type === 'leader') {
        if (
          ['preLeader', 'preUserInfoLeader', 'preEmpOrgLeader'].includes(
            this.value.metadata.operator_value.leader_type,
          )
        ) {
          this.approvalSelect = 'pre';
        } else if (
          ['currentLeader', 'currentUserInfoLeader', 'currentEmpOrgLeader'].includes(
            this.value.metadata.operator_value.leader_type,
          )
        ) {
          this.approvalSelect = 'current';
        }
      } else {
        this.approvalSelect = this.value.metadata.operator_type;
      }
      // 初始化当前可选的按属性配置的审批人列表
      this.refreshUserListByTag({
        ...this.value.metadata.operator_value.attribute_value_map,
      });
      // 初始化当前可选的选择审批人列表
      this.initSelectedUser();
    },
    // 开始节点初始化
    startNodeInit() {
      const { objectId } = this.$route.query;
      if (objectId) {
        const obecjtName =
          this.businessEntityList.find((object) => object.id === objectId)?.name || '';
        this.valueUpdate('metadata.trigger.resource', obecjtName);
      }
    },
    // 数据处理节点初始化
    cloudFunctionInit() {
      this.$request({
        data: {
          page: 0,
          size: 100000,
          search_key: '',
        },
        url: this.$api.getFuncList,
      }).then(({ list }) => {
        this.cloudFunctionList = list.filter(({ func_type }) => func_type === 0 || func_type === 4);
      });
    },
    valueUpdate(path, value) {
      console.log('meow?', path, value);
      this.$emit('update', {
        path,
        value,
      });
    },
    // 输入/输出变量
    variableOpen(type) {
      this.variableType = type;
      this.variableList = [...(this.value[type] || [])];
      this.$nextTick(() => {
        this.variableVisible = true;
      });
    },
    variableClose() {
      this.variableVisible = false;
      this.variableList = [];
    },
    variableSave(data) {
      this.valueUpdate(this.variableType, data);
      this.variableClose();
    },
    // 选择是否为审批业务时重置属性数据
    bizTypeChange(e) {
      this.valueUpdate('subref', e);
      if (this.value.metadata.operator_type) {
        this.valueUpdate('metadata.operator_value', {
          ..._.cloneDeep(defaultUserNodeFormValue),
        });
      }
    },
    // 选择审批人变更时修改数据 并清空不相关的数据
    approvalChange(e) {
      if (
        [
          'current',
          'pre',
          'currentLeader',
          'preLeader',
          'currentUserInfoLeader',
          'currentEmpOrgLeader',
          'preUserInfoLeader',
          'preEmpOrgLeader',
        ].includes(e)
      ) {
        this.valueUpdate('metadata.operator_type', 'leader');
        let leaderType = e;
        if (e === 'current') {
          leaderType = 'currentLeader';
        }
        if (e === 'pre') {
          leaderType = 'preLeader';
        }
        this.valueUpdate('metadata.operator_value', {
          ...this.value.metadata.operator_value,
          leader_type: leaderType,
          attribute_keys: [],
          attribute_value_map: {
            role: [],
            department: [],
            region: [],
          },
          attribute_checked_user: [],
          candidate_user: [],
        });
        this.candidateUserList = [];
      } else if (e === 'attribute') {
        this.valueUpdate('metadata.operator_type', 'attribute');
        this.valueUpdate('metadata.operator_value.candidate_user', []);
        this.candidateUserList = [];
      } else if (e === 'custom_condition') {
        this.valueUpdate('metadata.operator_type', 'custom_condition');
        this.valueUpdate('metadata.operator_value.candidate_user', []);
        this.candidateUserList = [];
      } else if (e === 'candidate') {
        this.valueUpdate('metadata.operator_type', 'candidate');
        this.valueUpdate('metadata.operator_value', {
          ...this.value.metadata.operator_value,
          attribute_checked_user: [],
          attribute_keys: [],
          attribute_value_map: {
            role: [],
            department: [],
            region: [],
          },
        });
      }
    },
    // 获取选择审批人的可选列表
    getUserList: _.debounce(function (input) {
      if (!input) {
        // 已经完成了选择 当前应该展示所有已选审批人的数据
        this.initSelectedUser();
      } else {
        // 正在输入新数据的清空 按关键字请求数据 这个数据将接在已选审批人数据之后
        this.$request({
          url: this.$api.getUserList,
          data: {
            page: 1,
            page_size: 100,
            keyword: input,
          },
          cb: ({ data }) => {
            this.candidateUserList = data;
          },
          showLoading: false,
        });
      }
    }, 200),
    initSelectedUser() {
      const regexp = /\((.*)\)/;
      if (this.value.metadata.operator_value.candidate_user.length > 0) {
        const accountList = this.value.metadata.operator_value.candidate_user.map((i) => {
          const result = regexp.exec(i);
          return result ? result[1] : '';
        });
        // 获取初始进入时的已选择用户列表
        this.$request({
          url: this.$api.getUserList,
          data: {
            page: 1,
            page_size: 100,
            account_list: accountList,
          },
          cb: ({ data }) => {
            this.selectedUserList = data;
            this.candidateUserList = [];
          },
          showLoading: false,
        });
      }
    },
    // 选择指定审批人
    candidateUserChange(list) {
      this.valueUpdate('metadata.operator_value.candidate_user', list);
      if (list.length > 1) {
        if (!this.value.metadata.operator_value.candidate_sign_type) {
          this.valueUpdate('metadata.operator_value.candidate_sign_type', 'orSign');
        }
      } else {
        this.valueUpdate('metadata.operator_value.candidate_sign_type', '');
      }
    },
    // 选择自定义条件标签
    customConditionChange(list) {
      this.valueUpdate('metadata.operator_value.custom_condition', list);
    },
    // 获取可选的审批人属性列表
    getRoleSelectedList(tag) {
      // 审批人求角色列表
      this.$request({
        url: this.$api.getApprovalUserAttributes,
        data: {
          appid: this.info.app_id || 0,
          tag,
          page: 1,
          page_size: 99999,
        },
        cb: ({ values }) => {
          this.userAttributeSelectInfo[tag] = values.map((value) => ({
            label: value,
            value,
          }));
        },
        showLoading: false,
      });
    },
    getCoustomConditionTags() {
      // 审批人求角色列表
      this.$request({
        url: this.$api.getApprovalUserAttributes,
        data: {
          appid: this.info.app_id || 0,
          page: 1,
          tag: 'customized',
          page_size: 99999,
        },
        cb: ({ values }) => {
          this.coustomConditionTags = values.map((value) => ({
            label: value,
            value,
          }));
        },
        showLoading: false,
      });
    },
    handleApprovalUserSelectedAttrubiesChange(list, key) {
      this.valueUpdate('metadata.operator_value.attribute_value_map', {
        ...this.value.metadata.operator_value.attribute_value_map,
        [key]: list,
      });

      this.refreshUserListByTag({
        ...this.value.metadata.operator_value.attribute_value_map,
        [key]: list,
      });
    },
    refreshUserListByTag(valueMap) {
      const tags = [];
      Object.keys(valueMap)?.forEach((tag) => {
        if (valueMap[tag].length) {
          tags.push({
            tag,
            values: valueMap[tag],
          });
        }
      });
      console.log('meowtag', tags, valueMap);
      this.getApprovalUserListByTag(tags);
    },
    getApprovalUserListByTag(tags = []) {
      this.attributesLoading = true;
      this.$request({
        url: this.$api.getApprovalUserListByTag,
        data: {
          appid: this.info.app_id || 0,
          tags,
          page: 1,
          page_size: 99999,
        },
        cb: ({ user_list }) => {
          const computedResData = user_list?.map(this.showUserList) || [];
          this.valueUpdate(
            'metadata.operator_value.attribute_checked_user',
            this.value.metadata.operator_value.attribute_checked_user.filter((value) => {
              return computedResData.some((resItem) => resItem.value === value);
            }),
          );

          this.userListByTag = computedResData;
          this.attributesLoading = false;
        },
        showLoading: false,
      });
    },
    // 更新审批人属性
    changeAttributeKeys(key, value) {
      let list = this.value.metadata.operator_value.attribute_keys;
      if (value) {
        list.push(key);
      } else {
        list = list.filter((i) => i !== key);
      }
      // 没有被选中的属性 需要清空已选项
      const attributeValueMapClear = {};
      USER_PROPERTITY.forEach(({ key }) => {
        if (!list.includes(key)) {
          attributeValueMapClear[key] = [];
        }
      });

      this.valueUpdate('metadata.operator_value.attribute_keys', list);
      this.valueUpdate('metadata.operator_value.attribute_value_map', {
        ...this.value.metadata.operator_value.attribute_value_map,
        ...attributeValueMapClear,
      });

      this.refreshUserListByTag({
        ...this.value.metadata.operator_value.attribute_value_map,
        ...attributeValueMapClear,
      });
    },
    // 变更空审批人时的自动选择策略
    changeFindStrategy(e) {
      this.valueUpdate('metadata.operator_value.leader_find_strategy', e);
      this.valueUpdate('metadata.operator_value.custom_condition_find_strategy', e);
      this.valueUpdate('metadata.operator_value.recursive_find_leader_enable', false);
    },
    // 变更多个审批人策略
    changeSignType(e) {
      this.valueUpdate('metadata.operator_value.candidate_sign_type', e);
      this.valueUpdate('metadata.operator_value.attribute_sign_type', e);
      this.valueUpdate('metadata.operator_value.custom_condition_sign_type', e);
    },
    // 格式化用户下拉列表
    showUserList(item) {
      return {
        label: `${item.name}${item.description ? `-${item.description}` : ''}`,
        value: `(${item.account})`,
      };
    },
    // 搜索云函数
    getFunctionList: _.debounce(function (input) {
      if (input) {
        this.$request({
          url: this.$api.getFuncList,
          data: {
            page: 0,
            size: 20,
            search_key: input,
          },
          cb: ({ list }) => {
            this.cloudFunctionList = list.filter(
              ({ func_type }) => func_type === 0 || func_type === 4,
            );
          },
          showLoading: false,
        });
      }
    }, 200),
  },
};
